import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = { class: "mt-24 pb-[52px] lg:pb-0" };
var _hoisted_2 = {
    key: 0,
    class: "hidden container py-12 items-start flex-wrap sm:flex lg:flex-nowrap"
};
var _hoisted_3 = { class: "order-3 lg:order-1 w-[290px] shrink-0" };
var _hoisted_4 = {
    href: "https://skillspace.ru",
    rel: "noopener noreferrer",
    target: "_blank"
};
var _hoisted_5 = { class: "mt-6 px-4 py-3 rounded-lg bg-gray-100 text-gray-400" };
var _hoisted_6 = { class: "mt-7 flex h-[40px]" };
var _hoisted_7 = {
    class: "inline-flex grow",
    href: "https://t.me/skillspaceru",
    rel: "noopener noreferrer",
    target: "_blank"
};
var _hoisted_8 = { class: "ml-3 text-gray-400" };
var _hoisted_9 = {
    class: "ml-5 inline-flex",
    href: "https://vk.com/skillspace",
    rel: "noopener noreferrer",
    target: "_blank"
};
var _hoisted_10 = {
    class: "ml-5 inline-flex",
    href: "https://www.youtube.com/@skillspace4431",
    rel: "noopener noreferrer",
    target: "_blank"
};
var _hoisted_11 = { class: "order-1 w-1/2 ml-0 mb-12 lg:order-2 lg:mt-0 lg:w-auto lg:ml-[30px] xl:ml-[60px]" };
var _hoisted_12 = { class: "mb-10 text-gray-500 font-medium" };
var _hoisted_13 = ["href"];
var _hoisted_14 = { class: "order-2 mb-12 w-1/2 lg:order-4 lg:mt-0 lg:w-auto lg:ml-[30px] xl:ml-[60px]" };
var _hoisted_15 = { class: "mb-10 text-gray-500 font-medium" };
var _hoisted_16 = ["href"];
var _hoisted_17 = { class: "order-4 ml-12 mt-14 lg:mt-0 lg:ml-[30px] xl:ml-[70px] w-[260px] shrink-0" };
var _hoisted_18 = {
    class: "flex",
    href: "https://mrqz.me/skillspace",
    rel: "noopener noreferrer",
    target: "_blank"
};
var _hoisted_19 = { class: "flex w-full justify-start items-center relative" };
var _hoisted_20 = /*#__PURE__*/ _createElementVNode("img", {
    class: "w-5 h-5 mr-4",
    src: "/img/common/components/footer/sales2.png"
}, null, -1);
var _hoisted_21 = { class: "flex w-full justify-start items-center relative" };
var _hoisted_22 = { class: "container text-center flex-col flex items-center justify-center" };
var _hoisted_23 = ["href"];
var _hoisted_24 = { key: 0 };
var _hoisted_25 = {
    class: "text-gray-500 hover:underline",
    href: "https://skillspace.ru/referral",
    rel: "noopener noreferrer",
    target: "_blank"
};
var _hoisted_26 = {
    key: 1,
    class: "py-6 bg-[#F5F5F6]"
};
var _hoisted_27 = { class: "container flex items-center justify-between flex-col sm:flex-row" };
var _hoisted_28 = { class: "order-3 sm:order-1" };
var _hoisted_29 = { class: "mt-8 sm:mt-0 items-center justify-center flex sm:hidden" };
var _hoisted_30 = {
    href: "https://skillspace.ru",
    rel: "noopener noreferrer",
    target: "_blank"
};
var _hoisted_31 = { class: "mt-7 sm:mt-0 text-sm text-gray-400 font-medium sm:text-base" };
var _hoisted_32 = { class: "w-full sm:w-auto flex items-center order-1 sm:order-2" };
var _hoisted_33 = {
    class: "grow inline-flex",
    href: "https://apps.apple.com/ru/app/skillspace/id1578915606",
    rel: "noopener noreferrer",
    target: "_blank"
};
var _hoisted_34 = /*#__PURE__*/ _createElementVNode("p", { class: "ml-3 text-base lg:hidden" }, " App Store ", -1);
var _hoisted_35 = { class: "ml-3 text-base hidden lg:inline-flex" };
var _hoisted_36 = {
    class: "grow inline-flex ml-4",
    href: "https://play.google.com/store/apps/details?id=ru.skillspace.client",
    rel: "noopener noreferrer",
    target: "_blank"
};
var _hoisted_37 = /*#__PURE__*/ _createElementVNode("p", { class: "ml-3 text-base lg:hidden" }, " Google Play ", -1);
var _hoisted_38 = { class: "ml-3 text-base hidden lg:inline-flex" };
var _hoisted_39 = { class: "order-2 grow mt-4 sm:hidden w-full flex justify-center" };
var _hoisted_40 = { class: "text-base" };
import { ref, computed } from 'vue';
import passData from '@common/utils/PassData';
import { useI18n } from 'vue-i18n';
import CurrentApp from '@common/utils/CurrentApp';
import ChangeLang from '@common/components/ChangeLang.vue';
import Auth from '@common/modules/auth';
import { GrantedActionsEnum } from '@common/enums';
import { openLink } from '@common/utils/Helpers/Helpers';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BaseFooter',
    setup: function (__props) {
        var appName = computed(function () { return CurrentApp.getInstance()._component.name; });
        var isShowButtonChangeLocale = computed(function () { return appName.value === 'AppStudent'; });
        var t = useI18n().t;
        var currentYear = ref((new Date).getFullYear());
        var platformLinks = computed(function () { return [
            {
                label: t('platformLinks.forOnlineSchools'),
                url: 'https://skillspace.ru/online-school',
            },
            {
                label: t('platformLinks.forCorporateTraining'),
                url: 'https://skillspace.ru/corporate',
            },
            {
                label: t('platformLinks.partnerProgram'),
                url: 'https://skillspace.ru/referral',
            },
        ]; });
        var employeeLawLinks = computed(function () {
            return Auth.hasActions([GrantedActionsEnum.ACTION_SCHOOL_TARIFF_AND_PAYMENT])
                ? [
                    {
                        label: t('employeeLawLinks.privacyPolicy'),
                        url: '/docs/policy',
                    },
                    {
                        label: t('employeeLawLinks.licenseAgreement'),
                        url: '/docs/license',
                    },
                    {
                        label: t('employeeLawLinks.agencyAgreement'),
                        url: '/docs/oferta',
                    },
                    {
                        label: t('employeeLawLinks.recurringPayments'),
                        url: 'https://skillspace.ru/docs/recurring-agreement',
                    },
                    {
                        label: t('employeeLawLinks.accountDataRetention'),
                        url: 'https://skillspace.ru/docs/recurring-card-data',
                    },
                ]
                : [];
        });
        var showTreaty = computed(function () { return !passData.dontUseDogovor; });
        var studentLawLinks = computed(function () {
            var links = [
                {
                    label: t('studentLawLinks.privacyPolicy'),
                    url: "/docs/policy",
                },
            ];
            if (showTreaty.value) {
                links.push({
                    label: t('studentLawLinks.offerAgreement'),
                    url: "/docs/oferta",
                });
            }
            return links;
        });
        var isStudent = window.__buildName === 'appStudent';
        var whiteLabelHideLogo = passData.schoolSettings.whiteLabelHideLogo;
        var lawLinks = computed(function () {
            return isStudent ? studentLawLinks.value : employeeLawLinks.value;
        });
        return function (_ctx, _cache) {
            var _component_e_icon = _resolveComponent("e-icon");
            var _component_e_button = _resolveComponent("e-button");
            return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
                (!_unref(whiteLabelHideLogo))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("a", _hoisted_4, [
                                _createVNode(_component_e_icon, {
                                    class: "text-primary w-[104px]",
                                    icon: "brands/skillspace"
                                })
                            ]),
                            _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('platformDescription')), 1),
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("a", _hoisted_7, [
                                    _createVNode(_component_e_button, {
                                        class: "grow",
                                        type: "secondary"
                                    }, {
                                        default: _withCtx(function () { return [
                                            _createVNode(_component_e_icon, {
                                                class: "text-gray-400 w-4 h-4",
                                                icon: "brands/telegram"
                                            }),
                                            _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(t)('telegramChannel')), 1)
                                        ]; }),
                                        _: 1
                                    })
                                ]),
                                _createElementVNode("a", _hoisted_9, [
                                    _createVNode(_component_e_button, {
                                        class: "w-10 h-10 rounded-lg",
                                        size: "nosize",
                                        type: "secondary"
                                    }, {
                                        default: _withCtx(function () { return [
                                            _createVNode(_component_e_icon, {
                                                class: "text-gray-400 w-4 h-4",
                                                icon: "brands/vk"
                                            })
                                        ]; }),
                                        _: 1
                                    })
                                ]),
                                _createElementVNode("a", _hoisted_10, [
                                    _createVNode(_component_e_button, {
                                        class: "w-10 h-10 rounded-lg",
                                        size: "nosize",
                                        type: "secondary"
                                    }, {
                                        default: _withCtx(function () { return [
                                            _createVNode(_component_e_icon, {
                                                class: "text-gray-400 w-4 h-4",
                                                icon: "brands/youtube"
                                            })
                                        ]; }),
                                        _: 1
                                    })
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(t)('platform')), 1),
                            _createElementVNode("ul", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(platformLinks.value, function (link) {
                                    return (_openBlock(), _createElementBlock("li", {
                                        key: link.url,
                                        class: "mt-6 first:mt-0"
                                    }, [
                                        _createElementVNode("a", {
                                            href: link.url,
                                            class: "text-gray-400 hover:text-dark",
                                            rel: "noopener noreferrer",
                                            target: "_blank"
                                        }, _toDisplayString(link.label), 9, _hoisted_13)
                                    ]));
                                }), 128))
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(t)('documents')), 1),
                            _createElementVNode("ul", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lawLinks.value, function (link) {
                                    return (_openBlock(), _createElementBlock("li", {
                                        key: link.url,
                                        class: "mt-6 first:mt-0"
                                    }, [
                                        _createElementVNode("a", {
                                            href: link.url,
                                            class: "text-gray-400 hover:text-dark",
                                            rel: "noopener noreferrer",
                                            target: "_blank"
                                        }, _toDisplayString(link.label), 9, _hoisted_16)
                                    ]));
                                }), 128))
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                            (isShowButtonChangeLocale.value)
                                ? (_openBlock(), _createBlock(ChangeLang, { key: 0 }))
                                : _createCommentVNode("", true),
                            _createElementVNode("a", _hoisted_18, [
                                _createVNode(_component_e_button, {
                                    class: "mb-5 w-full rounded-lg h-12 px-5 group/button shadow-custom bg-white",
                                    size: "nosize",
                                    type: "white"
                                }, {
                                    default: _withCtx(function () { return [
                                        _createElementVNode("div", _hoisted_19, [
                                            _hoisted_20,
                                            _createElementVNode("p", null, _toDisplayString(_unref(t)('signUpForDemo')), 1),
                                            _createVNode(_component_e_icon, {
                                                class: "w-3 h-3 transition-all opacity-50 group-hover/button:translate-x-1 absolute right-1",
                                                icon: "arrow-right-long"
                                            })
                                        ])
                                    ]; }),
                                    _: 1
                                })
                            ]),
                            _createVNode(_component_e_button, {
                                class: "w-full rounded-lg h-12 px-5 group/button",
                                size: "nosize",
                                type: "primary",
                                onClick: _cache[0] || (_cache[0] = function ($event) { return (_unref(openLink)('https://skillspace.ru/')); })
                            }, {
                                default: _withCtx(function () { return [
                                    _createElementVNode("div", _hoisted_21, [
                                        _createVNode(_component_e_icon, {
                                            class: "w-4 h-4 mr-4 opacity-50",
                                            icon: "check-circle1"
                                        }),
                                        _createElementVNode("p", null, _toDisplayString(_unref(t)('startYourCourseFree')), 1),
                                        _createVNode(_component_e_icon, {
                                            class: "w-3 h-3 transition-all opacity-50 group-hover/button:translate-x-1 absolute right-0",
                                            icon: "arrow-right-long"
                                        })
                                    ])
                                ]; }),
                                _: 1
                            })
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", {
                    class: _normalizeClass([[
                            _unref(whiteLabelHideLogo) ? 'pb-8' : 'pb-2 sm:hidden'
                        ], "pt-8 bg-[#F5F5F6]"])
                }, [
                    _createElementVNode("div", _hoisted_22, [
                        (isShowButtonChangeLocale.value)
                            ? (_openBlock(), _createBlock(ChangeLang, { key: 0 }))
                            : _createCommentVNode("", true),
                        _createElementVNode("ul", {
                            class: _normalizeClass([[
                                    _unref(whiteLabelHideLogo) ? 'flex items-center justify-center flex-wrap' : 'space-y-5'
                                ], "space-x-6"])
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lawLinks.value, function (link) {
                                return (_openBlock(), _createElementBlock("li", {
                                    key: link.url
                                }, [
                                    _createElementVNode("a", {
                                        class: _normalizeClass([[
                                                _unref(whiteLabelHideLogo) && 'py-2 inline-flex'
                                            ], "text-gray-500 hover:underline"]),
                                        href: link.url,
                                        rel: "noopener noreferrer",
                                        target: "_blank"
                                    }, _toDisplayString(link.label), 11, _hoisted_23)
                                ]));
                            }), 128)),
                            (!_unref(whiteLabelHideLogo))
                                ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                                    _createElementVNode("a", _hoisted_25, _toDisplayString(_unref(t)('becomePartner')), 1)
                                ]))
                                : _createCommentVNode("", true)
                        ], 2)
                    ])
                ], 2),
                (!_unref(whiteLabelHideLogo))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("div", _hoisted_29, [
                                    _createElementVNode("a", _hoisted_30, [
                                        _createVNode(_component_e_icon, {
                                            class: "text-primary w-[104px]",
                                            icon: "brands/skillspace"
                                        })
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_31, " © 2019-" + _toDisplayString(currentYear.value) + ", " + _toDisplayString(_unref(t)('copyright')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("a", _hoisted_33, [
                                    _createVNode(_component_e_button, {
                                        class: "grow bg-[#4D5766]/5 text-gray-500 sm:bg-transparent sm:text-gray-400 hover:bg-[#4D5766]/5 hover:text-gray-500",
                                        size: "large",
                                        type: "text"
                                    }, {
                                        default: _withCtx(function () { return [
                                            _createVNode(_component_e_icon, {
                                                class: "w-5 h-5",
                                                icon: "brands/apple"
                                            }),
                                            _hoisted_34,
                                            _createElementVNode("p", _hoisted_35, _toDisplayString(_unref(t)('availableInAppStore')), 1)
                                        ]; }),
                                        _: 1
                                    })
                                ]),
                                _createElementVNode("a", _hoisted_36, [
                                    _createVNode(_component_e_button, {
                                        class: "grow bg-[#4D5766]/5 text-gray-500 sm:bg-transparent sm:text-gray-400 hover:bg-[#4D5766]/5 hover:text-gray-500",
                                        size: "large",
                                        type: "text"
                                    }, {
                                        default: _withCtx(function () { return [
                                            _createVNode(_component_e_icon, {
                                                class: "w-5 h-5",
                                                icon: "brands/playmarket"
                                            }),
                                            _hoisted_37,
                                            _createElementVNode("p", _hoisted_38, _toDisplayString(_unref(t)('availableInGooglePlay')), 1)
                                        ]; }),
                                        _: 1
                                    })
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_39, [
                                _createVNode(_component_e_button, {
                                    size: "small",
                                    type: "primary",
                                    onClick: _cache[1] || (_cache[1] = function ($event) { return (_unref(openLink)('https://skillspace.ru/')); })
                                }, {
                                    default: _withCtx(function () { return [
                                        _createElementVNode("p", _hoisted_40, _toDisplayString(_unref(t)('startYourCourseFree')), 1),
                                        _createVNode(_component_e_icon, {
                                            class: "w-3 h-3 ml-4",
                                            icon: "arrow-right-long"
                                        })
                                    ]; }),
                                    _: 1
                                })
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
